import React from "react";
import { useNavigate } from "react-router-dom";
import loginBg from '../assets/svg/login.svg';
import "./EmployeeDashboard.css";

function EmployeeAbsenceRequest() {
  const navigate = useNavigate();

  return (
    <div className="dashboard-board-container" style={{
      minHeight: '100vh',
      background: `url(${loginBg}) center/cover no-repeat`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0
    }}>
      <div className="dashboard-board-content" style={{
        background: 'rgba(255,255,255,0.85)',
        borderRadius: 20,
        padding: 32,
        boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
        minWidth: 320,
        maxWidth: 400,
        minHeight: 340,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center'
      }}>
        <h2 style={{marginBottom: 24}}>Demande d'Absence à Venir</h2>
        <div style={{marginBottom: 32, minHeight: 80, width: '100%'}}>
          {/* Zone d'infos à venir */}
        </div>
        <div style={{display: 'flex', flexDirection: 'column', gap: 16, width: '100%'}}>
          <button className="absence" onClick={() => navigate("/absence-request/new")}>Nouvelle Demande</button>
          <button className="history" onClick={() => navigate("/absence-request/list")}>Demandes Effectuées</button>
          <button className="dashboard-back" onClick={() => navigate("/dashboard-board")}>Retour</button>
        </div>
      </div>
    </div>
  );
}

export default EmployeeAbsenceRequest; 